import {getLink} from '../linker'

const formatters = {
  // Show refnum link
  adjustLineRefLink: (cellVal, options, rowData) => {
    const ident = rowData.arTran?.id
    let href = getLink('arTran', ident)
    return `<a class="showLink" data-id="${ident}" href="${href}" >${cellVal}</a>`
  },

  adjustLineCustAccLink: (cellVal, options, rowData) => {
    const ident = rowData.arTran?.custAccount?.id 
    if(!ident) return ''
    let href = getLink('custAccount', ident)
    return `<a class="showLink" data-id="${ident}" href="${href}" >${cellVal}</a>`
  },
  stateName: (cellVal, options, rowData) => {
    //'Open(0), Closed(1), '', Void(3), Reversed(4)'
    const names = ['Open', 'Closed', '', 'Void', 'Reversed']
    return names[cellVal]
  },

  adjustLineInvoiceGridLink: (cellVal, options, rowData) => {
    const ident = rowData.arAdjust?.arTran?.id
    let href = getLink('arTran', ident)
    return `<a class="showLink" data-id="${ident}" href="${href}" >${cellVal}</a>`
  },

}

export default formatters
